module.exports = __webpack_public_path__ + "img/kcs.376cde89.svg";